hr {
  margin: 17px 0 15px;
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
  border-top: 1px;
  border-style: solid;
  border-color: var(--pm-grey11);

  &.dashed {
    border-style: dashed;
  }
}

:global(.dark) hr {
  border-color: var(--pm-grey3);
}

.br4400 {
  border-radius: 4px 4px 0 0 !important;
}
